import React from "react";
import PropTypes from "prop-types";
import YearPanel from "rc-calendar/lib/year/YearPanel";
import Picker from "rc-calendar/lib/Picker";
import enUS from "rc-calendar/lib/locale/en_US";
import frFR from "rc-calendar/lib/locale/fr_FR";
import moment from "moment";
import "rc-calendar/assets/index.css";
import ValidationUI from "../ValidationUI";
import "./DatePicker.css";
import {StyledInput} from "../Form/StyledInput";

// Calendar showing only rc-calendar's year panel, shaped so that Picker can
// drive it like its other calendars (value / onSelect / focus).
class YearCalendar extends React.Component {
  rootRef = React.createRef()

  focus() {
    this.rootRef.current && this.rootRef.current.focus()
  }

  onSelect = date => {
    const {disabledYear, onSelect} = this.props
    if (disabledYear && disabledYear(date.year())) return
    onSelect && onSelect(date)
  }

  render() {
    const {selectedValue, defaultValue, locale} = this.props
    return (
      <div ref={this.rootRef} tabIndex={0} className="rc-calendar DatePicker-calendar YearPicker-calendar">
        <YearPanel
          rootPrefixCls="rc-calendar"
          locale={locale}
          defaultValue={selectedValue || defaultValue || moment()}
          onSelect={this.onSelect}
          onDecadePanelShow={() => {}}
        />
      </div>
    );
  }
}

const YearPicker = ({
  value,
  path,
  required,
  onChange,
  open,
  onOpenChange,
  language = "en",
  placeholder = language === "fr" ? "Choisir une année" : "Pick a year...",
  error,
  touched,
  disabled,
  disabledYear,
  t
}) => {
  const year = parseInt(value, 10)
  const momentValue = Number.isInteger(year) ? moment().year(year) : null

  return (
      <Picker
          animation="slide-up"
          calendar={<YearCalendar locale={language === "fr" ? frFR : enUS} disabledYear={disabledYear} />}
          value={momentValue}
          onChange={date => onChange(date ? date.year() : null)}
          open={open}
          onOpenChange={onOpenChange}
          disabled={disabled}
      >
        {
          ({value}) => (
              <div className="DatePicker-container">
                <StyledInput
                    path={path}
                    required={required}
                    placeholder={placeholder}
                    value={value ? String(value.year()) : ""}
                    t={t}
                />
                {touched && error && <ValidationUI error={error} />}
              </div>
          )
        }
      </Picker>
  );
};

YearPicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  language: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  disabledYear: PropTypes.func
};

export default YearPicker;
